import { FolderOpen, ArrowUpCircle, ArrowDownCircle } from "lucide-react";
import defaultAvatar from "../../assets/logo/logo.png";
import { resolveMedia } from "../../services/api";

export default function TransactionRow({ transaction, onView }) {
  const user = transaction.user; 
  const contact = user?.contact;
  const avatar = resolveMedia(user?.profilPicture, defaultAvatar);

  return (
    <tr>
      <td>
        <div className="userCell">
          <img src={avatar} alt="avatar" className="tableAvatar" />
          <div>
            <div className="userName">
              {user?.firstName} {user?.lastName}
            </div>
            <div className="userSub">@{user?.username || "utilisateur"}</div>
          </div>
        </div>
      </td>

      <td>
        <span className={`amountText ${transaction.isOutgoing ? "outgoing" : "incoming"}`}>
          {transaction.isOutgoing ? "-" : "+"} {transaction.amount.toLocaleString()} CFA
        </span>
      </td>

      <td className="descriptionCell">
        {transaction.description || "Aucune description"}
      </td>

      <td>
        <span className={`typeBadge ${transaction.isOutgoing ? "red" : "green"}`}>
          {transaction.isOutgoing ? (
            <><ArrowDownCircle size={14} /> Retrait</>
          ) : (
            <><ArrowUpCircle size={14} /> Recharge</>
          )}
        </span>
      </td>

      <td className="center">
        <div className="actions">
          <button
            type="button"
            className="iconBtn"
            title="Voir détails"
            onClick={() => onView?.(transaction)}
          >
            <FolderOpen size={18} />
          </button>
        </div>
      </td>
    </tr>
  );
}